module.exports = __webpack_public_path__ + "static/media/skello.4e617e53.png";